/** Hooks pour les liens d'affiliation. */

import { useQuery } from "@tanstack/react-query";
import {
  listDefaultAffiliations,
  resolveAffiliations,
  type Affiliation,
} from "@/api/affiliations";

/** Affiliations génériques (DPE seul). */
export function useDefaultAffiliations() {
  return useQuery({
    queryKey: ["affiliations", "default"],
    queryFn: listDefaultAffiliations,
    staleTime: 5 * 60_000,
  });
}

/** Affiliations résolues pour un contexte (liste d'améliorations). */
export function useResolvedAffiliations(improvements: string[], source = "scenario") {
  // Normalisation : tri pour avoir une clé stable même si l'ordre change
  const sorted = [...improvements].sort();
  return useQuery<Affiliation[]>({
    queryKey: ["affiliations", "resolved", sorted.join(","), source],
    queryFn: () => resolveAffiliations(sorted, source),
    enabled: sorted.length > 0,
    staleTime: 5 * 60_000,
  });
}
